import styles from './NextOrderLabel.module.scss';
import { DateStatus } from '@chewy/chat-library-common';

interface NextOrderLabelProps {
    message: DateStatus;
}

export default function NextOrderLabel({ message }: NextOrderLabelProps) {
    return (<div className={styles.container}>
        <span className={styles.label}>{message?.status}</span>
        <span className={styles.date}>{message?.label}</span>
    </div>)
}
